'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var coreComponentsCheckbox = require('@alfalab/core-components-checkbox');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"desktop":"select__desktop_1x6dd","mobile":"select__mobile_1x6dd"};
require('./index.css')

var Header = function (_a) {
    var _b;
    var onChange = _a.onChange, checked = _a.checked, indeterminate = _a.indeterminate, mobile = _a.mobile, dataTestId = _a.dataTestId;
    return (React__default.default.createElement("div", { className: cn__default.default((_b = {}, _b[styles.desktop] = !mobile, _b[styles.mobile] = mobile, _b)) },
        React__default.default.createElement(coreComponentsCheckbox.Checkbox, { block: true, indeterminate: indeterminate, size: 'm', onChange: onChange, checked: checked, label: '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435', dataTestId: dataTestId })));
};

exports.Header = Header;
